import React, { PureComponent, PropTypes } from 'react'
import BackButton from './BackButton'
import NextButton from './NextButton'
import styles from './styles'
import logo from './logo.png'

export default class BottomBar extends PureComponent {
  static propTypes = {
    goBack: PropTypes.func,
    next: PropTypes.func,
    text: PropTypes.string,
    hideNext: PropTypes.bool,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    hideNext: false,
  }

  get nextButton() {
    const { text, next, hideNext, disabled } = this.props
    if (hideNext) return
    return <NextButton onClick={next} disabled={disabled}>{text}</NextButton>
  }

  render() {
    const { goBack } = this.props
    return (
      <div className={styles.wrapper}>
        <div className={styles.section}>
          <BackButton onClick={goBack} />
        </div>
        <div className={styles.section}>
          <img
            alt='Greater Houston Neurological Institute logo'
            src={logo}
            className={styles.logo}
          />
        </div>
        <div className={styles.section}>
          {this.nextButton}
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Survey/BottomBar/BottomBar.js
 **/